import React, {useCallback, useContext, useState} from "react";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import {FormattedMessage} from "react-intl";
import {VirtualDepartDriverResponse} from "./VirtualDepartDriverReponse";
import {VirtualDepartDriverContext} from "./context/VirtualDepartDriverContext";
import Alert from "@amzn/meridian/alert";
import Loader from "@amzn/meridian/loader";
import {RESPONSE_TYPE, VIRTUAL_DEPART_DRIVER_RESET} from "./constants/VirtualDepartDriverConstants";

export const VirtualDepartDriverDialog = ({isModalOpen, onModelOpenChange, checkedDriver}) => {
    const {virtualDepartDriverModel, virtualDepartDriverDispatch} = useContext(VirtualDepartDriverContext);
    const closeModal = useCallback(() => resetVirtualDepartDriverModel(), []);
    const [isCASProcessOngoing, setCASProcessOngoing] = useState(false);

    function resetVirtualDepartDriverModel() {
        setCASProcessOngoing(false);
        onModelOpenChange(false);
        virtualDepartDriverDispatch({
            type: VIRTUAL_DEPART_DRIVER_RESET
        });
    }

    return (
        <Modal
            title={<FormattedMessage id="virtual.depart.driver" defaultMessage="Virtual Depart Driver"/>}
            open={isModalOpen}
            onClose={closeModal}
            scrollContainer="viewport"
            closeLabel="Close"
            width={500}>
            <Box height={100}>
                {!virtualDepartDriverModel.isLoading && !virtualDepartDriverModel.requestCompleted &&
                <Box>
                    <Text type="h100"><FormattedMessage id="virtual.depart.driver_confirmation"
                                                        values={{driverName: checkedDriver.driverName}}
                                                        defaultMessage="Click confirm to depart {driverName}"/></Text>
                    <br/>
                </Box>

                }
                {!virtualDepartDriverModel.isLoading && !virtualDepartDriverModel.requestCompleted && !isCASProcessOngoing &&
                <ModalFooter>
                    <Row spacingInset="small" alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="small" onClick={closeModal}>
                            Cancel
                        </Button>
                        <Button type="primary" size="small" onClick={() => setCASProcessOngoing(true)}>
                            Confirm
                        </Button>
                    </Row>
                </ModalFooter>
                }

                {!virtualDepartDriverModel.isLoading
                && virtualDepartDriverModel.requestCompleted
                && isCASProcessOngoing
                && virtualDepartDriverModel.type === RESPONSE_TYPE.SUCCESS
                && closeModal()}

                {!virtualDepartDriverModel.isLoading
                && virtualDepartDriverModel.requestCompleted
                && virtualDepartDriverModel.type !== RESPONSE_TYPE.SUCCESS
                && <Row alignmentHorizontal="center" alignmentVertical="center" height="100%">
                    <Alert type={virtualDepartDriverModel.type}>{virtualDepartDriverModel.message}</Alert>
                </Row>
                }

                { virtualDepartDriverModel.isLoading && !virtualDepartDriverModel.requestCompleted &&
                <Row alignmentHorizontal="center" alignmentVertical="center" height="100%">
                    <Loader type="circular"/>
                    <Text type="h200"><FormattedMessage id="virtual.depart.driver_loading"
                                                        defaultMessage="Departing driver"/></Text>
                </Row>
                }
                {isCASProcessOngoing &&
                <VirtualDepartDriverResponse checkedDriver={checkedDriver}/>}
            </Box>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/components/virtualDepartDriver/VirtualDepartDriverDialog.js